import SEO from '@/components/base/SEO';
import Navbar from '@/components/feature/Navbar';
import Footer from '@/components/feature/Footer';
import ScrollToTop from '@/components/base/ScrollToTop';
import Hero from './components/Hero';
import FeaturedArticles from './components/FeaturedArticles';
import CategoryOverview from './components/CategoryOverview';
import FAQ from './components/FAQ';

const baseUrl = 'https://haosexiaoyi.com';

export default function Home() {
  const schema = {
    '@context': 'https://schema.org',
    '@graph': [
      {
        '@type': 'Organization',
        name: '好色小姨故事集',
        url: baseUrl,
        description: '都市情感故事的深度解读平台，专注于「好色小姨」经典角色类型的人物分析、故事合集、创作灵感与情感逻辑。',
      },
      {
        '@type': 'WebSite',
        name: '好色小姨故事集',
        url: baseUrl,
        potentialAction: {
          '@type': 'SearchAction',
          target: `${baseUrl}/search?q={search_term_string}`,
          'query-input': 'required name=search_term_string',
        },
      },
      {
        '@type': 'WebPage',
        name: '好色小姨——都市情感故事精选合集',
        description: '「好色小姨」是都市言情与家庭伦理小说中备受关注的经典角色类型，本页精选相关故事、人物分析与创作灵感。',
        url: baseUrl,
        isPartOf: {
          '@type': 'WebSite',
          name: '好色小姨故事集',
          url: baseUrl,
        },
      },
    ],
  };

  return (
    <>
      <SEO
        title="首页"
        description="「好色小姨」是都市言情与家庭伦理小说中备受关注的经典角色类型，本页精选相关故事、人物分析与创作灵感，带你深入了解这一充满戏剧张力的角色设定及其背后的情感逻辑。"
        keywords="好色小姨,好色小姨故事合集,都市言情小说角色,家庭伦理故事,经典小说人物设定,情感故事推荐,都市小说角色分析"
        canonicalUrl={baseUrl}
        ogImage="https://readdy.ai/api/search-image?query=Elegant%20Chinese%20literary%20website%20social%20preview%20image%2C%20warm%20golden%20aesthetic%2C%20book%20pages%20and%20ink%20wash%20texture%2C%20sophisticated%20literary%20atmosphere%2C%20minimalist%20design%20with%20amber%20accents&width=1200&height=630&seq=og-home-2026&orientation=landscape"
        schema={schema}
      />
      <Navbar />
      <main>
        <Hero />
        <FeaturedArticles />
        <CategoryOverview />
        <FAQ />
      </main>
      <Footer />
      <ScrollToTop />
    </>
  );
}